import "@hotwired/turbo-rails"
import "./controllers"
import AOS from "aos"

// Import CSS files
import "aos/dist/aos.css"  // Add AOS CSS
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"

// Import JS
import "leaflet"
import "leaflet.markercluster"
import L from "leaflet"

// Initialize AOS only when needed
document.addEventListener("turbo:load", () => {
  if (typeof AOS !== 'undefined' && document.querySelector('[data-aos]')) {
    AOS.init()
  }
})

window.L = L

